import { ChangeDetectionStrategy, Component, computed, input, output } from "@angular/core";
import { MatIcon } from "@angular/material/icon";
import { MatButton } from "@angular/material/button";
import { AreaMode, AreaSelection } from "../../../model/detection/detection.models";

const MODE_META: Record<AreaMode, { icon: string; label: string }> = {
  point: { icon: "circle", label: "Point + Radius" },
  rectangle: { icon: "box", label: "Rectangle" },
  polygon: { icon: "poly", label: "Custom Polygon" },
  locations: { icon: "place", label: "Imported points (CSV)" },
  boundary: { icon: "upload_file", label: "Imported boundary" },
  search: { icon: "manage_search", label: "Search result" },
};

@Component({
  selector: "lib-area-summary-card",
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatIcon, MatButton],
  templateUrl: "./area-summary-card.component.html",
})
export class AreaSummaryCardComponent {
  readonly area = input.required<AreaSelection>();

  readonly showChangeButton = input(false);

  readonly changeArea = output<void>();

  protected readonly meta = computed(() => MODE_META[this.area().mode] ?? MODE_META.polygon);

  protected readonly hasArea = computed(() => !!this.area().geometryWkt);

  protected readonly secondaryText = computed(() => {
    const a = this.area();
    if (!a.geometryWkt) return "No area selected";
    if (a.mode === "locations") {
      const f = a.importedFile;
      return f ? `${f.name} · ${f.featureCount} points` : "Area defined";
    }
    if (a.mode === "search") {
      return "Area from previous search results";
    }
    return "Area defined";
  });
}
